import { WidgetAutocheck } from "@redotech/redo-model/widget";

export function isTryFirstSetup(autocheck: WidgetAutocheck) {
  return autocheck.tryFirst?.sellingPlanId;
}
